"use client";
import { useEffect, useState } from "react";

// Drop the recorded screen presentation at public/managed-demo.mp4 (plus an
// optional public/managed-demo-poster.jpg). Until the file exists, the block
// renders a placeholder so the layout is already in place.
const VIDEO_SRC = "/managed-demo.mp4";
const POSTER_SRC = "/managed-demo-poster.jpg";

type Props = {
  title: string;
  placeholderTitle: string;
  placeholderBody: string;
};

export const ManagedVideo = ({ title, placeholderTitle, placeholderBody }: Props) => {
  const [hasVideo, setHasVideo] = useState<boolean | null>(null);

  useEffect(() => {
    fetch(VIDEO_SRC, { method: "HEAD" })
      .then((r) => setHasVideo(r.ok))
      .catch(() => setHasVideo(false));
  }, []);

  return (
    <figure className="relative">
      <div className="relative rounded-2xl border border-neutral-800 bg-neutral-950 shadow-[0_0_60px_rgba(239,68,68,0.15)] overflow-hidden">
        <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-red-500/10 pointer-events-none z-10" />
        <div className="relative aspect-video bg-gradient-to-br from-neutral-950 via-neutral-900 to-red-950/30">
          {hasVideo === true ? (
            <video
              src={VIDEO_SRC}
              poster={POSTER_SRC}
              controls
              playsInline
              preload="metadata"
              className="absolute inset-0 h-full w-full object-cover"
            />
          ) : (
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
              <span className="inline-flex h-16 w-16 items-center justify-center rounded-full border border-red-500/40 bg-red-500/10 text-red-300">
                <svg viewBox="0 0 24 24" fill="currentColor" className="h-6 w-6 translate-x-0.5" aria-hidden>
                  <path d="M8 5v14l11-7z" />
                </svg>
              </span>
              <p className="mt-5 text-base md:text-lg font-semibold text-white">{placeholderTitle}</p>
              <p className="mt-2 max-w-md text-sm text-neutral-400 leading-relaxed">{placeholderBody}</p>
            </div>
          )}
        </div>
      </div>
      <figcaption className="mt-3 text-xs text-neutral-500">{title}</figcaption>
    </figure>
  );
};
